module.exports = __webpack_public_path__ + "img/celtiis.495d7c10.jpg";